import logos from "./logos";
import { FC } from "react";
import { IBankLogo } from "./types";
import { NORNE_CENTERID } from "@portal/assets/banks";

const BankLogo: FC<IBankLogo> = ({ centerId }) => {
  const Comp = GetLogoName(centerId);
  if (Comp === "") return <div>{Comp}</div>;

  const isNorne = centerId === NORNE_CENTERID;

  return (
    <div className="flex max-h-[60px]">
      {isNorne ? (
        <div>
          <Comp style={{ width: "140px", margin: "0px" }} />
        </div>
      ) : (
        <Comp style={{ minWidth: GetMinWidthForLogo(centerId), minHeight: "40px", maxHeight: "60px", margin: "3px 0" }} />
      )}
    </div>
  );
};

const GetMinWidthForLogo = (centerId: string) => {
  if (centerId === "2220") return "80px";
  return "140px";
};

const GetLogoName = (centerId: string) => {
  const key = `centerId_${centerId}`;
  if (key in logos) {
    return logos[key as keyof typeof logos];
  }
  return "";
};
export default BankLogo;
